import React from 'react';
import { isEolMoment } from 'utils/constants';
import {
  getEolPhaseTitlePrefix,
  stripEolPhaseNamePrefix
} from 'utils/eolPhaseTitlePrefix';
import styles from './TimelineCard.module.scss';

const EOL_TITLE_PREFIX_COLOR = '#909090';

export { stripEolPhaseNamePrefix as stripEolNamePrefix } from 'utils/eolPhaseTitlePrefix';

interface CardTitleDisplayProps {
  projectType?: string | null;
  /** EOL release phase name (Initial Announcement, End of Sale, …). */
  releasePhase?: string | null;
  /** Raw card title from the API. */
  title: string;
  /** Phased-offer / default display title from {@link getRtmPhasedTitleParts}. */
  displayTitle: string;
  className?: string;
}

/** Roadmap card title — grey stage prefix for End of Life moments. */
export const CardTitleDisplay: React.FC<CardTitleDisplayProps> = ({
  projectType,
  releasePhase,
  title,
  displayTitle,
  className
}) => {
  if (isEolMoment(projectType)) {
    const prefixLabel = getEolPhaseTitlePrefix(releasePhase).replace(/:$/, '');
    return (
      <span className={className}>
        <span
          className={styles.eolTitlePrefix}
          style={{ color: EOL_TITLE_PREFIX_COLOR }}
        >
          {prefixLabel}:{' '}
        </span>
        {stripEolPhaseNamePrefix(title)}
      </span>
    );
  }

  return <span className={className}>{displayTitle}</span>;
};
